import { Vector3 } from 'three';
import { threeEngine } from 'Domain/Scene/Engine/ThreeEngine';
import { clearBoundingBoxes, computeAndDisplayTeethIntersection } from 'Domain/Scene/Handler/CollisionHandler';

/**
 * Rattache un mesh au mandiGroup en préservant sa position world.
 * À appeler pour toute gencive ou dent mandi qui doit suivre le ByteJump.
 * @param {Mesh} mesh
 */
export const reparentToMandiGroup = (mesh) => {
    const mandiGroup = threeEngine.getMandiGroup();
    if (!mandiGroup) return;
    const worldPos = new Vector3();
    mesh.getWorldPosition(worldPos);
    mandiGroup.add(mesh); // retire automatiquement du parent précédent
    mandiGroup.worldToLocal(worldPos);
    mesh.position.copy(worldPos);
};

/**
 * Applique l'ajustement mandibulaire (Bite Jump)
 * @param {Object} vector - Vecteur d'ajustement {x, y, z}
 * @param {boolean} isActive - Si l'ajustement doit être activé
 */
export const applyMandiAdjust = (vector, isActive) => {
    const mandiGroup = threeEngine.getMandiGroup();
    if (!mandiGroup) return;

    const mandiAdjustVector = new Vector3(vector.x, vector.y, vector.z);
    
    if (isActive) {
        mandiGroup.position.copy(mandiAdjustVector);
        threeEngine.getMandiMarkupGroup().position.copy(mandiAdjustVector);
    } else {
        mandiGroup.position.set(0, 0, 0);
        threeEngine.getMandiMarkupGroup().position.set(0, 0, 0);
    }

    clearBoundingBoxes();
    computeAndDisplayTeethIntersection();
};

/**
 * Vérifie si un vecteur est non nul
 * @param {Object} v - Vecteur {x, y, z}
 * @returns {boolean}
 */
export const vectorIsNonZero = (v) => v.x !== 0 || v.y !== 0 || v.z !== 0;

/**
 * Construit un Vector3 à partir d'un objet simple
 * @param {Object} v - {x, y, z}
 * @returns {Vector3}
 */
export const buildMandiAdjustVector = (v) => new Vector3(v.x, v.y, v.z);
